import { render, staticRenderFns } from "./VtkRenderer.vue?vue&type=template&id=c1fe5df4&"
import script from "./VtkRenderer.vue?vue&type=script&lang=js&"
export * from "./VtkRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports